import client from "../Client/HttpClient";
import { IAcademicPerformanceGradesModel } from "@/interfaces/modules";

const ApiPath = "AcademicPerformanceGrades";

export default {
    GetPerformances: (): Promise<IAcademicPerformanceGradesModel[]> => client.get(`${ApiPath}`),
    GetPerformanceById: (data: IAcademicPerformanceGradesModel): Promise<IAcademicPerformanceGradesModel> => client.get(`${ApiPath}/${data.Id}`),
    GetByPeriod: (data: IAcademicPerformanceGradesModel): Promise<IAcademicPerformanceGradesModel[]> => client.get(`${ApiPath}/byPeriod/${data.PeriodId}/${data.CourseGroupId}/${data.SubjectId}`),
    GetByYear: (data: IAcademicPerformanceGradesModel): Promise<IAcademicPerformanceGradesModel[]> => client.get(`${ApiPath}/byYear/${data.AcademicYearId}/${data.CourseGroupId}/${data.SubjectId}`),
    PostPerformance: (data: IAcademicPerformanceGradesModel): Promise<IAcademicPerformanceGradesModel> => client.post(`${ApiPath}`, data),
    PutPerformance: (data: IAcademicPerformanceGradesModel): Promise<IAcademicPerformanceGradesModel> => client.put(`${ApiPath}/${data.Id}`, data),
    DeletePerformance: (data: IAcademicPerformanceGradesModel): Promise<void> => client.delete(`${ApiPath}/${data.Id}`),
};
